import * as types from '../actions/actionTypes';

export default function vimeoReducer(state = {}, action) {
    switch (action.type) {
        case types.GET_VIMEO_SUCCESS:
            let newState = {...state};
            newState[action.id] = {name: action.vimeo.name, description: action.vimeo.description};

            return newState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/vimeoReducer.js